import React from "react";
import {formatDate, parseDate} from "../utils";
import DatePicker from "react-date-picker";

import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';


function isString(x) {
  return Object.prototype.toString.call(x) === "[object String]"
}


const DateInput = ({onFieldEdit, value, adata, hasError, defaultDate}) => {

    let d1 = value
    if(value && isString(value)) {
        d1 = value.split("T")[0]
        d1 = parseDate(d1)
    }

    return <DatePicker
            value={d1}
            calendarProps={{
                //defaultValue: defaultDate,
                value: d1 || defaultDate
            }}
            maxDate={new Date(2999,1,1)}
            format={"yyyy-MM-dd"}
            dayPlaceholder={"dd"}
            monthPlaceholder={"mm"}
            yearPlaceholder={"yyyy"}
            onChange={value => {
                const v = formatDate(value)
                onFieldEdit(adata.fieldName, v)
            }}
        />
}


export default DateInput